// extracted by mini-css-extract-plugin
export default {"button":"LogWithEsia_button__mNl1q","text":"LogWithEsia_text__1t-Oj"};